import { Col, Row, Spin } from 'antd';
import React, { useCallback, useMemo, useState } from 'react';

import ReportTagsAPI from '../../../api/reportTags';
import useInfiniteQuery from '../../../hooks/queries/useInfiniteQuery';
import { checkIfElementIsScrolledToBottom } from '../../../utils/common';
import Select from '../../Select';

const ReportTagSelect = props => {
  const { onChange, value } = props;
  const [initialCount, setInitialCount] = useState();

  const { query: reportTagsQuery, flatPages } = useInfiniteQuery(
    {
      staleTime: Infinity,
      queryKey: ['fetchReportTags'],
      queryFn: ({ pageParam = 1 }) =>
        new ReportTagsAPI().fetchReportTags({}, pageParam, 25, JSON.stringify({ name: 1 })),
      onSuccess: ({ pages }) => {
        if (
          Array.isArray(pages) &&
          typeof pages[0]?.totalCount !== 'undefined' &&
          typeof initialCount === 'undefined'
        ) {
          setInitialCount(pages[0]?.totalCount);
        }
      },
    },
    'totalCount',
    'documents',
  );

  const handleOptionsScroll = useCallback(
    e => {
      const bottom = checkIfElementIsScrolledToBottom(e.target);
      if (bottom && !reportTagsQuery.isFetchingNextPage && reportTagsQuery.hasNextPage) {
        reportTagsQuery.fetchNextPage();
      }
    },
    [reportTagsQuery],
  );

  const handleChange = useCallback(
    (values, options) => {
      if (typeof onChange === 'function') {
        const fullSelectedItems = flatPages.filter(item => values.includes(item._id));

        onChange(fullSelectedItems);
      }
    },
    [onChange, flatPages],
  );

  const reportTagsOptions = useMemo(() => {
    let optionsArray = flatPages.map(reportTag => ({
      value: reportTag._id,
      label: reportTag.name,
    }));

    return optionsArray;
  }, [flatPages]);

  return (
    <Select
      resetOnNoMatch={false}
      mode="multiple"
      onPopupScroll={handleOptionsScroll}
      value={value.map(valueOption => ({
        value: valueOption._id,
        label: valueOption.name,
      }))}
      onChange={handleChange}
      notFoundContent={
        reportTagsQuery.isFetching ? (
          <Row justify="center" align="middle">
            <Col>
              <Spin size="default" />
            </Col>
          </Row>
        ) : initialCount === 0 ? (
          'Empty'
        ) : undefined
      }
      options={reportTagsOptions}
    />
  );
};

export default ReportTagSelect;
